import axios from "axios";
import url from "@/utils/api/url";
import {isNavigationFailure} from "vue-router/src/util/errors";

const URL_STUDY = url.URL_API + '/study';

// 与学生报名、学习相关的URL
const URL_STUDY_STUDENT_CLASS = URL_STUDY + '/studentClass';
const URL_STUDY_STUDENT_CLASS_SIGNIN_CLASS = URL_STUDY + '/studentClass/class/signIn';
const URL_STUDY_STUDENT_CLASS_CLASS = URL_STUDY + '/studentClass/class';
const URL_STUDY_STUDENT_CLASS_COLLEGE = URL_STUDY + '/studentClass/college';
const URL_STUDY_STUDENT_CLASS_STUDENT = URL_STUDY + '/studentClass/student';
const URL_STUDY_STUDENT_CLASS_SCORE = URL_STUDY + '/studentClass/score';
const URL_STUDY_STUDENT_CLASS_SCORE_IMPORT = URL_STUDY + '/studentClass/score/import';
const URL_STUDY_STUDENT_CLASS_STATE = URL_STUDY + '/studentClass/state';
const URL_STUDY_STUDENT_CLASS_VERIFY = URL_STUDY + '/studentClass/verify';

// 与反馈相关的URL
const URL_STUDY_SURVEY = URL_STUDY + '/survey';
const URL_STUDY_SURVEY_TEMPLATE = URL_STUDY + '/survey/template';
const URL_STUDY_SURVEY_TEMPLATE_STATE = URL_STUDY + '/survey/template/state';
const URL_STUDY_SURVEY_TEMPLATE_ITEM = URL_STUDY + '/survey/template/item';

const URL_STUDY_SURVEY_PAPER = URL_STUDY + '/survey/paper';
const URL_STUDY_SURVEY_PAPER_STATE = URL_STUDY + '/survey/paper/state';
const URL_STUDY_SURVEY_PAPER_TEACHER_COURSE = URL_STUDY + '/survey/paper/teacherCourse';
const URL_STUDY_SURVEY_PAPER_STUDENT = URL_STUDY + '/survey/paper/student';

const URL_STUDY_ACHIEVEMENT_STUDENT = URL_STUDY + '/achievement/student';

const URL_STUDY_CERTIFICATE = URL_STUDY + '/certificate';
const URL_STUDY_CERTIFICATE_STUDENT = URL_STUDY + '/certificate/student';
const URL_STUDY_CERTIFICATE_PAGE_DATA = URL_STUDY + '/certificate/pageData';
const URL_STUDY_CERTIFICATE_MERGE_DOWN = URL_STUDY + '/certificate/mergeDown';

//删除证书 --- 二期添加
const URL_STUDY_CERTIFICATE_DELETE = URL_STUDY + '/certificate/delete';
const URL_STUDY_STUDENT_CLASS_CANCEL = URL_STUDY + '/studentClass/cancelCheck';

export default {
    studentClass: {
        getSignInClassData(studentId) {
            return axios.get(URL_STUDY_STUDENT_CLASS_SIGNIN_CLASS, {params: {studentId}});
        },

        getStudentClassDataByStudentId(studentId) {
            return axios.get(URL_STUDY_STUDENT_CLASS_CLASS, {params: {studentId}});
        },
        getStudentClassDataByClassId(classId) {
            return axios.get(URL_STUDY_STUDENT_CLASS_STUDENT, {params: {classId}});
        },
        getStudentClassDataByCollegeId(collegeId, state) {
            return axios.get(URL_STUDY_STUDENT_CLASS_COLLEGE, {params: {collegeId, state}});
        },

        getStudentClassInfo(studentClassId) {
            return axios.get(URL_STUDY_STUDENT_CLASS + '/' + studentClassId);
        },
        insertStudentClassInfo(info) {
            return axios.post(URL_STUDY_STUDENT_CLASS, info)
        },
        deleteStudentClassInfo(studentClassId) {
            return axios.delete(URL_STUDY_STUDENT_CLASS + '/' + studentClassId);
        },

        updateStudentClassScoreInfo(info) {
            return axios.put(URL_STUDY_STUDENT_CLASS_SCORE + '/' + info.studentClassId, info);
        },
        updateStudentClassStateInfo(info) {
            return axios.put(URL_STUDY_STUDENT_CLASS_STATE + '/' + info.studentClassId, info);
        },

        importStudentClassScoreData(parameters) {
            return axios.get(URL_STUDY_STUDENT_CLASS_SCORE_IMPORT, {params: parameters});
        },

        cancelStudentClassState(studentClassId){
            return axios.put(URL_STUDY_STUDENT_CLASS_CANCEL + '/' + studentClassId);
        },
        verifyStudentClassState(info) {
            return axios.post(URL_STUDY_STUDENT_CLASS_VERIFY,info);
        },
    },

    survey: {
        getSurveyData(surveyPaperId,classId) {
            return axios.get(URL_STUDY_SURVEY, {params: {surveyPaperId, classId}});
        },
        getSurveyInfo(surveyId) {
            return axios.get(URL_STUDY_SURVEY + '/' + surveyId);
        },
        insertSurveyInfo(info) {
            return axios.post(URL_STUDY_SURVEY, info);
        },

        template: {
            getSurveyTemplateData() {
                return axios.get(URL_STUDY_SURVEY_TEMPLATE);
            },
            getSurveyTemplateInfo(surveyTemplateId) {
                return axios.get(URL_STUDY_SURVEY_TEMPLATE + '/' + surveyTemplateId);
            },
            insertSurveyTemplateInfo(info) {
                return axios.post(URL_STUDY_SURVEY_TEMPLATE, info);
            },
            updateSurveyTemplateInfo(info) {
                return axios.put(URL_STUDY_SURVEY_TEMPLATE + '/' + info.surveyTemplateId, info);
            },
            deleteSurveyTemplateInfo(surveyTemplateId) {
                return axios.delete(URL_STUDY_SURVEY_TEMPLATE + '/' + surveyTemplateId);
            },
            updateSurveyTemplateState(info) {
                return axios.put(URL_STUDY_SURVEY_TEMPLATE_STATE + '/' + info.surveyTemplateId, info);
            },
            
            item: {
                getSurveyTemplateItemData(surveyTemplateId) {
                    return axios.get(URL_STUDY_SURVEY_TEMPLATE_ITEM, {params: {surveyTemplateId}});
                },
                getSurveyTemplateItemInfo(surveyTemplateItemId) {
                    return axios.get(URL_STUDY_SURVEY_TEMPLATE_ITEM + '/' + surveyTemplateItemId);
                },
                insertSurveyTemplateItemInfo(info) {
                    return axios.post(URL_STUDY_SURVEY_TEMPLATE_ITEM, info);
                },
                updateSurveyTemplateItemInfo(info) {
                    return axios.put(URL_STUDY_SURVEY_TEMPLATE_ITEM + '/' + info.surveyTemplateItemId, info);
                },
                deleteSurveyTemplateItemInfo(surveyTemplateItemId) {
                    return axios.delete(URL_STUDY_SURVEY_TEMPLATE_ITEM + '/' + surveyTemplateItemId);
                },
            }
        },
        
        paper: {
            getSurveyPaperData(classId) {
                return axios.get(URL_STUDY_SURVEY_PAPER, {params: {classId}});
            },
            getSurveyPaperDataByStudent(studentId) {
                return axios.get(URL_STUDY_SURVEY_PAPER_STUDENT, {params: {studentId}});
            },
            getSurveyPaperInfo(surveyPaperId) {
                return axios.get(URL_STUDY_SURVEY_PAPER + '/' + surveyPaperId);
            },
            insertSurveyPaperInfo(info) {
                return axios.post(URL_STUDY_SURVEY_PAPER, info);
            },
            updateSurveyPaperInfo(info) {
                return axios.put(URL_STUDY_SURVEY_PAPER + '/' + info.surveyPaperId, info);
            },
            deleteSurveyPaperInfo(surveyPaperId) {
                return axios.delete(URL_STUDY_SURVEY_PAPER + '/' + surveyPaperId);
            },
            updateSurveyPaperState(info) {
                return axios.put(URL_STUDY_SURVEY_PAPER_STATE + '/' + info.surveyPaperId, info);
            },
            teacherCourse: {
                getSurveyPaperTeacherCourseData(surveyPaperId) {
                    return axios.get(URL_STUDY_SURVEY_PAPER_TEACHER_COURSE, {params: {surveyPaperId}});
                },
                getSurveyPaperTeacherCourseInfo(surveyPaperTeacherCourseId) {
                    return axios.get(URL_STUDY_SURVEY_PAPER_TEACHER_COURSE + '/' + surveyPaperTeacherCourseId);
                },
                insertSurveyPaperTeacherCourseInfo(info) {
                    return axios.post(URL_STUDY_SURVEY_PAPER_TEACHER_COURSE, info);
                },
                deleteSurveyPaperTeacherCourseInfo(surveyPaperTeacherCourseId) {
                    return axios.delete(URL_STUDY_SURVEY_PAPER_TEACHER_COURSE + '/' + surveyPaperTeacherCourseId);
                },
            }
        }
    },
    achievement: {
        getStudentAchievementDataByStudentId(studentId, projectId) {
            return axios.get(URL_STUDY_ACHIEVEMENT_STUDENT, {params: {studentId, projectId}});
        },
    },
    certificate: {
        deleteCertificate(pkId){
            return axios.delete(URL_STUDY_CERTIFICATE_DELETE, {params: {pkId}});
        },
        getClassCertificateData(classId) {
            return axios.get(URL_STUDY_CERTIFICATE, {params: {classId}});
        },
        getStudentCertificateInfo(studentClassId) {
            return axios.get(URL_STUDY_CERTIFICATE + '/' + studentClassId);
        },

        getStudentCertificateData(studentId) {
            return axios.get(URL_STUDY_CERTIFICATE_STUDENT, {params: {studentId}});
        },

        getCertificatePageData(filterCondition) {
            return axios.get(URL_STUDY_CERTIFICATE_PAGE_DATA, {params: filterCondition});
        },

        buildStudentCertificateInfo(info) {
            return axios.post(URL_STUDY_CERTIFICATE, info);
        },
        mergeDown(classId) {
            return axios.get(URL_STUDY_CERTIFICATE_MERGE_DOWN, {params: {classId}});
        }
    },
}